<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M11.9597 3.64461C12.1599 3.16338 12.8416 3.16338 13.0418 3.64461L15.2563 8.96905C15.3407 9.17192 15.5315 9.31053 15.7505 9.32809L21.4987 9.78892C22.0182 9.83057 22.2289 10.4789 21.833 10.818L17.4535 14.5695C17.2867 14.7124 17.2138 14.9367 17.2648 15.1504L18.6028 20.7597C18.7237 21.2666 18.1722 21.6673 17.7274 21.3957L12.8062 18.3898C12.6187 18.2753 12.3828 18.2753 12.1953 18.3898L7.2741 21.3957C6.82931 21.6673 6.2778 21.2666 6.39873 20.7597L7.73674 15.1504C7.78772 14.9367 7.71484 14.7124 7.54797 14.5695L3.16847 10.818C2.77265 10.4789 2.98331 9.83057 3.50283 9.78892L9.25101 9.32809C9.47003 9.31053 9.66081 9.17192 9.74519 8.96905L11.9597 3.64461Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgStarEmpty',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
